import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.1",
  "description": "Turborepo 2.1은 영향을 받은 패키지 감지 및 저장소 탐색 도구를 통해 저장소와의 통합을 개선합니다.",
  "date": "2024/08/27",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.1은 저장소와의 통합을 개선합니다. 주요 기능은 다음과 같습니다:"
  }, {
    "heading": "",
    "content": "영향을 받은 패키지 그래프 감지: --affected를 사용하여 변경된 작업만 실행"
  }, {
    "heading": "",
    "content": "저장소 탐색 도구: turbo ls 및 turbo run으로 패키지와 작업을 더 빠르게 찾기"
  }, {
    "heading": "",
    "content": "터미널 UI 개선: 로그 선택, 작업 검색, 크기 조정 등"
  }, {
    "heading": "",
    "content": "확장된 구성 옵션: turbo.json을 사용한 기본값에 대한 더 많은 유연성"
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 지금 업데이트하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "Turborepo의 Remote Caching은 모든 머신에서 단일 캐시를 공유하므로\n동일한 작업을 두 번 수행할 필요가 없습니다. 하지만 변경되지 않은 패키지를 완전히 무시할 수 있다면 어떨까요?"
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "이제 turbo run과 함께 --affected 플래그를 사용하여 현재 브랜치의 최신 커밋과 저장소의 기본 브랜치(보통 main 또는 master) 사이의 변경 사항이 있는 패키지를 자동으로 대상으로 지정할 수 있습니다.\nturbo는 Package Graph를 사용하여 직접 변경 사항이 있거나 내부 의존성에 변경 사항이 있는 패키지에 대해 작업을 실행합니다."
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "다음과 같은 상황에서 이 플래그를 사용하고 싶을 것입니다:"
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "monorepo의 패키지 전체에서 많은 작업을 실행하고 있으며, 코드 변경 사항이 있는 패키지에서만 해당 작업을 실행하고 싶을 때."
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "Remote Cache를 사용하고 있지 않지만, CI에서 가능한 한 적은 작업만 수행하고 싶을 때."
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "Remote Cache를 사용하고 있으며 대규모 저장소에 있을 때. 캐시에서 복원할 작업의 양을 최소화하면 네트워크를 통해 전송할 데이터가 줄어들어 캐시 복원이 더 빨라집니다."
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "이미 고급 필터링 기법 또는 turbo-ignore를 사용하여 --affected와 동일하거나 유사한 동작을 만들고 있을 때. 이 새 플래그를 사용하여 스크립팅을 단순화할 기회가 있을 것입니다."
  }, {
    "heading": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "저장소-탐색-도구",
    "content": "저장소가 성장하고 변경됨에 따라 찾고 있는 것을 빠르게 찾기 어려울 수 있습니다.\n저장소를 더 빠르고 쉽게 이해할 수 있도록 작업, 패키지 및 관계를 신속하게 표시하고자 합니다."
  }, {
    "heading": "turbo-run",
    "content": "turbo run(작업 인수 없이)을 사용하여 저장소에서 사용 가능한 작업 목록을 가져옵니다. 이 명령은 필터 및 자동 패키지 스코핑과도 작동합니다."
  }, {
    "heading": "turbo-run",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "turbo-ls",
    "content": "turbo ls를 사용하여 위치와 함께 저장소의 모든 패키지 목록을 가져오거나, 특정 패키지로 필터링하여 내부 의존성 및 작업 요약을 확인하세요.\nturbo ls는 --filter 및 --affected도 지원하므로 변경된 패키지 목록을 쉽게 수집할 수 있습니다."
  }, {
    "heading": "turbo-ls",
    "content": "turbo ls는 특정 형식으로 결과를 반환하는 데 사용할 수 있는 실험적 --output 플래그를 지원합니다.\n예를 들어, --output=json을 사용하여 다른 도구 또는 사용자 정의 스크립트에 대한 입력을\n더 쉽게 만들 수 있습니다. 이전에 변경된 패키지 목록을 검색하기 위해서만\nturbo build --dry=json을 사용했다면 turbo ls --affected --output=json을 시도해 보세요.\n자세한 내용은 문서를 참조하고 출력 형식에 대한 피드백은 turbo ls\nRFC에 남겨주세요."
  }, {
    "heading": "turbo-ls",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "터미널-ui-개선",
    "content": "Turborepo 2.0에서 로그의 명확성을 개선하고 로컬 개발에서 상호작용 작업을 허용하기 위해 새로운 터미널 UI를 출시했습니다. 여러분의 피드백을 듣고 이 UI를 다듬는 것을 우선시하여 2.0 패치 및 이번 2.1 릴리스에서 개선 사항을 출시했습니다:"
  }, {
    "heading": "터미널-ui-개선",
    "content": "클립보드에 복사하기 위한 로그 강조 표시 (PR)"
  }, {
    "heading": "터미널-ui-개선",
    "content": "작업 목록을 통한 검색 (PR)"
  }, {
    "heading": "터미널-ui-개선",
    "content": "터미널 크기가 변경될 때 더 깔끔한 레이아웃 크기 조정 (PR)"
  }, {
    "heading": "터미널-ui-개선",
    "content": "작업 목록의 캐시 히트에 대한 새 아이콘 (PR)"
  }, {
    "heading": "터미널-ui-개선",
    "content": "Watch Mode가 재시작을 트리거할 때 작업 상태 표시기 업데이트 (PR)"
  }, {
    "heading": "터미널-ui-개선",
    "content": "터미널 UI가 종료된 후 출력 로그 존중 (PR)"
  }, {
    "heading": "터미널-ui-개선",
    "content": "훌륭한 터미널 UI 경험을 구축하는 것은 독특한 도전 과제이며, 우리는 이 경험을 계속 반복하고 있습니다. monorepo를 위한 훌륭한 UI를 만드는 작업을 계속하는 동안 지속적인 피드백에 감사드립니다."
  }, {
    "heading": "확장된-구성-옵션",
    "content": "이번 릴리스에서는 저장소의 기본값에 대해 더 많은 유연성을 제공하기 위해 turbo.json에 더 많은 키를 추가합니다. 이번 릴리스의 새로운 키는 다음과 같습니다:"
  }, {
    "heading": "확장된-구성-옵션",
    "content": "많은 또는 모든 turbo 호출에서 이러한 구성에 대한 플래그 동등물을 사용하여 다음과 같은 명령으로 코드베이스를 어지럽혔을 수 있습니다:"
  }, {
    "heading": "확장된-구성-옵션",
    "content": "이제 Turborepo의 기존 구성 모델을 사용하여 turbo.json의 중앙 집중식 구성으로 이를 단순화할 수 있습니다:"
  }, {
    "heading": "확장된-구성-옵션",
    "content": "turbo.json은 저장소의 기본값을 설정합니다."
  }, {
    "heading": "확장된-구성-옵션",
    "content": "시스템 환경 변수는 특정 환경에서 동작을 사용자 정의합니다."
  }, {
    "heading": "확장된-구성-옵션",
    "content": "플래그는 turbo의 특정 호출에 대한 동작을 사용자 정의합니다."
  }, {
    "heading": "확장된-구성-옵션",
    "content": "사용 가능한 옵션 및 구성에 대해 자세히 알아보려면 문서를 방문하세요."
  }, {
    "heading": "기타-개선-사항",
    "content": "스트리밍 UI에서 작업 이름의 색상을 결정론적으로 만들기 위해 #9023에 기여하여 #2564를 닫은 Shaharking에게 특별히 감사드립니다. 이를 통해 turbo run 호출 간 작업을 더 쉽게 비교할 수 있습니다."
  }, {
    "heading": "기타-개선-사항",
    "content": "전체 변경 로그는 vercel/turborepo에서 확인하세요."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo 2.0 출시 이후 놀라운 채택과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "25.9k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "2.9M+ 주간 NPM 다운로드"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 428년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "--affected로-변경된-패키지에-대한-작업-실행",
    "content": "--affected로 변경된 패키지에 대한 작업 실행"
  }, {
    "id": "저장소-탐색-도구",
    "content": "저장소 탐색 도구"
  }, {
    "id": "turbo-run",
    "content": "turbo run"
  }, {
    "id": "turbo-ls",
    "content": "turbo ls"
  }, {
    "id": "터미널-ui-개선",
    "content": "터미널 UI 개선"
  }, {
    "id": "확장된-구성-옵션",
    "content": "확장된 구성 옵션"
  }, {
    "id": "기타-개선-사항",
    "content": "기타 개선 사항"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#--affected로-변경된-패키지에-대한-작업-실행",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--affected"
    }), "로 변경된 패키지에 대한 작업 실행"]
  })
}, {
  depth: 2,
  url: "#저장소-탐색-도구",
  title: _jsx(_Fragment, {
    children: "저장소 탐색 도구"
  })
}, {
  depth: 3,
  url: "#turbo-run",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "turbo run"
    })
  })
}, {
  depth: 3,
  url: "#turbo-ls",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "turbo ls"
    })
  })
}, {
  depth: 2,
  url: "#터미널-ui-개선",
  title: _jsx(_Fragment, {
    children: "터미널 UI 개선"
  })
}, {
  depth: 2,
  url: "#확장된-구성-옵션",
  title: _jsx(_Fragment, {
    children: "확장된 구성 옵션"
  })
}, {
  depth: 2,
  url: "#기타-개선-사항",
  title: _jsx(_Fragment, {
    children: "기타 개선 사항"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.1"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, August 27th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['tomknickman', 'anthonyshew', 'chrisolszewski', 'nicholasyang', 'dimitrimitropoulos']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.1은 저장소와의 통합을 개선합니다. 주요 기능은 다음과 같습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#run-tasks-for-changed-packages-with---affected",
          children: _jsx(_components.strong, {
            children: "영향을 받은 패키지 그래프 감지"
          })
        }), ": ", _jsx(_components.code, {
          children: "--affected"
        }), "를 사용하여 변경된 작업만 실행"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#repository-exploration-tools",
          children: _jsx(_components.strong, {
            children: "저장소 탐색 도구"
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo ls"
        }), " 및 ", _jsx(_components.code, {
          children: "turbo run"
        }), "으로 패키지와 작업을 더 빠르게 찾기"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#terminal-ui-improvements",
          children: _jsx(_components.strong, {
            children: "터미널 UI 개선"
          })
        }), ": 로그 선택, 작업 검색, 크기 조정 등"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#expanded-configuration-options",
          children: _jsx(_components.strong, {
            children: "확장된 구성 옵션"
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo.json"
        }), "을 사용한 기본값에 대한 더 많은 유연성"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 지금 업데이트하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "--affected로-변경된-패키지에-대한-작업-실행",
      children: [_jsx(_components.code, {
        children: "--affected"
      }), "로 변경된 패키지에 대한 작업 실행"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), "은 모든 머신에서 단일 캐시를 공유하므로\n동일한 작업을 두 번 수행할 필요가 없습니다. 하지만 변경되지 않은 패키지를 완전히 무시할 수 있다면 어떨까요?"]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.code, {
        children: "turbo run"
      }), "과 함께 ", _jsx(_components.code, {
        children: "--affected"
      }), " 플래그를 사용하여 현재 브랜치의 최신 커밋과 저장소의 기본 브랜치(보통 ", _jsx(_components.code, {
        children: "main"
      }), " 또는 ", _jsx(_components.code, {
        children: "master"
      }), ") 사이의 변경 사항이 있는 패키지를 자동으로 대상으로 지정할 수 있습니다.\n", _jsx(_components.code, {
        children: "turbo"
      }), "는 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "를 사용하여 직접 변경 사항이 있거나 내부 의존성에 변경 사항이 있는 패키지에 대해 작업을 실행합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "다음과 같은 상황에서 이 플래그를 사용하고 싶을 것입니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "monorepo의 패키지 전체에서 많은 작업을 실행하고 있으며, 코드 변경 사항이 있는 패키지에서만 해당 작업을 실행하고 싶을 때."
      }), "\n", _jsxs(_components.li, {
        children: ["Remote Cache를 사용하고 있지 ", _jsx(_components.em, {
          children: "않지만"
        }), ", CI에서 가능한 한 적은 작업만 수행하고 싶을 때."]
      }), "\n", _jsx(_components.li, {
        children: "Remote Cache를 사용하고 있으며 대규모 저장소에 있을 때. 캐시에서 복원할 작업의 양을 최소화하면 네트워크를 통해 전송할 데이터가 줄어들어 캐시 복원이 더 빨라집니다."
      }), "\n", _jsxs(_components.li, {
        children: ["이미 ", _jsx(_components.a, {
          href: "/docs/reference/run#advanced-filtering-examples",
          children: "고급 필터링 기법"
        }), " 또는 ", _jsx(_components.a, {
          href: "/docs/reference/turbo-ignore",
          children: _jsx(_components.code, {
            children: "turbo-ignore"
          })
        }), "를 사용하여 ", _jsx(_components.code, {
          children: "--affected"
        }), "와 동일하거나 유사한 동작을 만들고 있을 때. 이 새 플래그를 사용하여 스크립팅을 단순화할 기회가 있을 것입니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "저장소-탐색-도구",
      children: "저장소 탐색 도구"
    }), "\n", _jsx(_components.p, {
      children: "저장소가 성장하고 변경됨에 따라 찾고 있는 것을 빠르게 찾기 어려울 수 있습니다.\n저장소를 더 빠르고 쉽게 이해할 수 있도록 작업, 패키지 및 관계를 신속하게 표시하고자 합니다."
    }), "\n", _jsx(_components.h3, {
      id: "turbo-run",
      children: _jsx(_components.code, {
        children: "turbo run"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run"
      }), "(작업 인수 없이)을 사용하여 저장소에서 사용 가능한 작업 목록을 가져옵니다. 이 명령은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#using-filters",
        children: "필터"
      }), " 및 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
        children: "자동 패키지 스코핑"
      }), "과도 작동합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 저장소의 모든 작업 나열"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 특정 패키지의 작업 나열"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@repo/ui"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 자동 패키지 스코핑 사용"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "cd"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " packages/ui"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: " &&"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "turbo-ls",
      children: _jsx(_components.code, {
        children: "turbo ls"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo ls"
      }), "를 사용하여 위치와 함께 저장소의 모든 패키지 목록을 가져오거나, 특정 패키지로 필터링하여 내부 의존성 및 작업 요약을 확인하세요.\n", _jsx(_components.code, {
        children: "turbo ls"
      }), "는 ", _jsx(_components.code, {
        children: "--filter"
      }), " 및 ", _jsx(_components.code, {
        children: "--affected"
      }), "도 지원하므로 변경된 패키지 목록을 쉽게 수집할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 저장소의 모든 패키지 나열"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# `web` 패키지의 의존성 및 작업 나열"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "## 영향을 받은 패키지 나열"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo ls"
        }), "는 특정 형식으로 결과를 반환하는 데 사용할 수 있는 실험적 ", _jsx(_components.code, {
          children: "--output"
        }), " 플래그를 지원합니다.\n예를 들어, ", _jsx(_components.code, {
          children: "--output=json"
        }), "을 사용하여 다른 도구 또는 사용자 정의 스크립트에 대한 입력을\n더 쉽게 만들 수 있습니다. 이전에 변경된 패키지 목록을 검색하기 위해서만\n", _jsx(_components.code, {
          children: "turbo build --dry=json"
        }), "을 사용했다면 ", _jsx(_components.code, {
          children: "turbo ls --affected --output=json"
        }), "을 시도해 보세요.\n자세한 내용은 문서를 참조하고 출력 형식에 대한 피드백은 ", _jsx(_components.code, {
          children: "turbo ls"
        }), "\n", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/discussions/8811",
          children: "RFC"
        }), "에 남겨주세요."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/ls",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "터미널-ui-개선",
      children: "터미널 UI 개선"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 2.0에서 로그의 명확성을 개선하고 로컬 개발에서 상호작용 작업을 허용하기 위해 ", _jsx(_components.a, {
        href: "https://turborepo.com/blog/turbo-2-0#new-terminal-ui",
        children: "새로운 터미널 UI"
      }), "를 출시했습니다. 여러분의 피드백을 듣고 이 UI를 다듬는 것을 우선시하여 2.0 패치 및 이번 2.1 릴리스에서 개선 사항을 출시했습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["클립보드에 복사하기 위한 로그 강조 표시 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8713",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["작업 목록을 통한 검색 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/9042",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["터미널 크기가 변경될 때 더 깔끔한 레이아웃 크기 조정 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8996",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["작업 목록의 캐시 히트에 대한 새 아이콘 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8869",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Watch Mode가 재시작을 트리거할 때 작업 상태 표시기 업데이트 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8960",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["터미널 UI가 종료된 후 출력 로그 존중 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8612",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "훌륭한 터미널 UI 경험을 구축하는 것은 독특한 도전 과제이며, 우리는 이 경험을 계속 반복하고 있습니다. monorepo를 위한 훌륭한 UI를 만드는 작업을 계속하는 동안 지속적인 피드백에 감사드립니다."
    }), "\n", _jsx(_components.h2, {
      id: "확장된-구성-옵션",
      children: "확장된 구성 옵션"
    }), "\n", _jsxs(_components.p, {
      children: ["이번 릴리스에서는 저장소의 기본값에 대해 더 많은 유연성을 제공하기 위해 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 더 많은 키를 추가합니다. 이번 릴리스의 새로운 키는 다음과 같습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"envMode\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"loose\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"daemon\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"cacheDir\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./my-custom-directory/\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["많은 또는 모든 ", _jsx(_components.code, {
        children: "turbo"
      }), " 호출에서 이러한 구성에 대한 플래그 동등물을 사용하여 다음과 같은 명령으로 코드베이스를 어지럽혔을 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --env-mode=loose"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-daemon"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache-dir=./my-custom-directory"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이제 Turborepo의 기존 구성 모델을 사용하여 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 중앙 집중식 구성으로 이를 단순화할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "은 저장소의 기본값을 설정합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "시스템 환경 변수"
        }), "는 특정 환경에서 동작을 사용자 정의합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["플래그는 ", _jsx(_components.code, {
          children: "turbo"
        }), "의 특정 호출에 대한 동작을 사용자 정의합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["사용 가능한 옵션 및 구성에 대해 자세히 알아보려면 ", _jsx(_components.a, {
        href: "/docs/reference/configuration",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "기타-개선-사항",
      children: "기타 개선 사항"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["스트리밍 UI에서 작업 이름의 색상을 결정론적으로 만들기 위해 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/9023",
          children: "#9023"
        }), "에 기여하여 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/issues/2564",
          children: "#2564"
        }), "를 닫은 ", _jsx(_components.a, {
          href: "https://github.com/Shaharking",
          children: "Shaharking"
        }), "에게 특별히 감사드립니다. 이를 통해 ", _jsx(_components.code, {
          children: "turbo run"
        }), " 호출 간 작업을 더 쉽게 비교할 수 있습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["전체 변경 로그는 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/releases/tag/v2.1.0",
        children: _jsx(_components.code, {
          children: "vercel/turborepo"
        })
      }), "에서 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-2-0",
        children: "Turborepo 2.0"
      }), " 출시 이후 놀라운 채택과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "25.9k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "2.9M+ 주간 NPM 다운로드"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 428년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
